import { createSlice } from '@reduxjs/toolkit';

interface User {
  id: string;
}

interface LoginData {
  access: string;
  refresh: string;
  user: User;
}

const initialState: LoginData = {
  access: '',
  refresh: '',
  user: {
    id: ''
  }
};

export const loginData = createSlice({
  name: 'loginData',
  initialState,
  reducers: {
    setLoginData: (state, { payload }) => ({ ...state, ...payload })
  }
});

export const { setLoginData } = loginData.actions;

export default loginData.reducer;
